import { __decorate } from "tslib";
import { Component, Vue, Prop, } from "vue-property-decorator";
let TabsContent = class TabsContent extends Vue {
    tabsClick(data) {
        this.$emit("change", data.value, data);
    }
};
__decorate([
    Prop({
        default: () => {
            return [];
        },
        type: Array,
    })
], TabsContent.prototype, "tabsList", void 0);
__decorate([
    Prop({ default: "" })
], TabsContent.prototype, "tabsActive", void 0);
__decorate([
    Prop({ default: "" })
], TabsContent.prototype, "type", void 0);
__decorate([
    Prop({ default: false })
], TabsContent.prototype, "titleCustom", void 0);
TabsContent = __decorate([
    Component({
        components: {},
    })
], TabsContent);
export default TabsContent;
